<app-challenges-base-card
  [challenge]="challenge"
  [createdByLabel]="getChallengeCreatedByLabel()"
  [icon]="'badge_challenge'"
  [iconSize]="'2x'"
  [progressLabel]="getChallengeProgressTitleLabel()"
>
  <div *ngIf="challenge.contents?.length > 0" class="content">
    <opac-button (click)="showContents()">
      {{ 'button.viewContent' | translate }}
    </opac-button>
  </div>

  <div *ngIf="challenge.contents?.length > 0" class="controls" slot="controls">
    <opac-button (click)="showContents()">
      {{ 'button.viewContent' | translate }}
    </opac-button>
  </div>
</app-challenges-base-card>
